module.exports = __webpack_public_path__ + "static/img/icons8-ratings.36b480ca.svg";